<page-heading
  [title]="'report.templatesAnalytics.pageTitle' | translate"
  [description]="'report.templatesAnalytics.pageDescription' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="formGroup">
          <div class="row g-2">
            <div class="col-xs-12 col-lg-8 input-trend-search">
              <input
                type="search"
                #searchBox
                class="form-control"
                [placeholder]="'report.templatesAnalytics.searchPlaceholder' | translate"
                [formControl]="searchControl"
                (input)="filterTemplates($event)"
              />
              <span class="mdi mdi-magnify search-icon ml-2"></span>
            </div>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterChannel"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelChannel | translate }}</span>
              </button>
              <mat-menu #filterChannel="matMenu">
                @if (listChannel.length > 0) {
                <button mat-menu-item (click)="searchByChannel(null)">
                  {{ 'report.templatesAnalytics.all' | translate }}
                </button>
                @for (channel of listChannel; track $index) {
                <button mat-menu-item (click)="searchByChannel(channel)">
                  {{ channel.name }}
                </button>
                } } @else {
                <h6 class="text-muted m-1">{{ 'report.templatesAnalytics.noResultsFound' | translate }}</h6>
                }
              </mat-menu>
            </div>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterCategory"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>
                  {{
                    selectedCategory
                      ? dictionaryCategory(selectedCategory.toUpperCase())
                      : ('report.templatesAnalytics.category' | translate)
                  }}</span
                >
              </button>
              <mat-menu #filterCategory="matMenu">
                <button mat-menu-item (click)="searchByChannel(null)">
                  {{ 'report.templatesAnalytics.all' | translate }}
                </button>
                @for (category of listCategories; track category.key) {
                <button mat-menu-item (click)="filterByCategory(category.key)">
                  {{ category.label | translate }}
                </button>
                }
              </mat-menu>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="card">
  @if(loadingContent) {
    <content-loading-card />
  }

  @if(!loadingContent && templates.length === 0) {
    <empty-records-component
      [message]="'report.templatesAnalytics.emptyMessage' | translate"
      [subMessage]="'report.templatesAnalytics.emptySubMessage' | translate"
      [icon]="'mdi mdi-alert-circle-outline'"
    />
  }

  @if(!loadingContent && templates.length > 0) {
    <div class="card-body table-responsive">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th class="text-primary-emphasis">{{ 'report.templatesAnalytics.templateName' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.templatesAnalytics.categoryColumn' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.templatesAnalytics.language' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.templatesAnalytics.status' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for(template of templates; track template.id) {
            <tr (click)="openTemplateDetail(template)" style="cursor: pointer;">
              <td>{{ template.name }}</td>
              <td>{{ dictionaryCategory(template.category) }}</td>
              <td>{{ dictionaryLanguage(template.language) }}</td>
              <td>{{ dictionaryStatus(template.status) }}</td>
            </tr>
          }
        </tbody>
      </table>
      @if (pager.total > pager.perPage) {
        <paginator [pager]="pager" (onPager)="loadPage($event)"/>
      }
    </div>
  }
</div>
